import React from 'react'

const ContactUs = () => {
  return (
    <div className='section'>
        <div className='w-screen justify-center items-center'>
            <div className='text-center break-words overflow-hidden sm:text-base md:text-2xl'>
                <p className='pt-5'>Email</p>
                <p className='py-2'>loremipsumdolor@lorem.com</p>
                <p className='pt-5'>Facebook: </p>
                <p className='py-2'><a href='https://www.facebook.com/groups/1634961666903617' target='_blank' rel='noreferrer'>https://www.facebook.com/groups/1634961666903617</a></p>
            </div>
        </div>
    </div>
  )
}

export default ContactUs